import AnimationScreen from './scenes/AnimationScreen';
import ClockScreen from './scenes/ClockScreen';
import EndScreen from './scenes/EndScreen';
import GameScreen from './scenes/GameScreen';
import IntroScreen from './scenes/IntroScreen';
import PracticeScreen from './scenes/PracticeScreen';
import SelectLevelScreen from './scenes/SelectLevelScreen';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [IntroScreen,AnimationScreen, SelectLevelScreen,PracticeScreen, ClockScreen, GameScreen, EndScreen],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: IntroScreen.KEY,

  // startScene: SelectLevelScreen.KEY,
  // startScene: PracticeScreen.KEY,
  // startScene: ClockScreen.KEY,
  // startScene: GameScreen.KEY,
  // startScene: EndScreen.KEY,

  MUSIC_ON: true,
  LEVELS_LOCKED: [false, false, true, true, true],
  CURRENT_LEVEL: 0,
  CLOCK_IS_ANALOG: false
};

export const DEFAULT_BUTTON_CONFIG = { pressAnimationConfig: { scale: 0.8 }, releaseAnimationConfig: { scale: 1 } };